import axios from "axios";

import { hideNotification, showNotificationError, showNotificationWarning } from "../../add-to-ici/redux/slice";
import { TEXT } from "../../../shared/constants/texts";
import { ROUTE } from "../../../shared/constants/routes";
import SessionService from "../../../shared/services/sessionService";
import ConfigService from "../../../shared/services/configService";

const configService = new ConfigService();
const sessionService = new SessionService();
const UNAUTHORISED_STATUS_CODE = 401;
const FORBIDDEN_STATUS_CODE = 403;

export const savedSearchApiCall = ({ dispatch, history, errorValidationMsg, retryFunctionCall }) => {
  const baseUrl = configService.getApiUrl().toString();
  const masterDataCT = configService.getSearchMasterDataContractType();
  const masterDataCTSysId = configService.getSearchMasterDataSysID();
  return dispatch(
    apiCall({
      requestBaseUrl: baseUrl,
      requestUrl: `SavedSearches/ForAddIn?id=${masterDataCTSysId}&contractType=${masterDataCT}`,
      requestMethod: TEXT.GET,
      history: history,
      errMsg: errorValidationMsg.ERROR_LOADING_SAVED_SEARCHES,
      onRetry: retryFunctionCall,
    })
  );
};

export const agreementApiCall = ({ dispatch, history, errorValidationMsg, retryFunctionCall, requestData }) => {
  const baseUrl = configService.getApiUrl().toString();
  return dispatch(
    apiCall({
      requestBaseUrl: baseUrl,
      requestUrl: `Search/ExecuteCustomizedSavedSearch`,
      requestMethod: TEXT.POST,
      requestData: requestData,
      history: history,
      errMsg: errorValidationMsg.ERROR_LOADING_AGREEMENTS,
      onRetry: retryFunctionCall,
    })
  );
};

export const associationPartOneApiCall = ({
  dispatch,
  history,
  errorValidationMsg,
  retryFunctionCall,
  requestData,
}) => {
  const { sysId, entityName } = requestData;
  const baseUrl = configService.getApiUrl().toString();
  return dispatch(
    apiCall({
      requestBaseUrl: baseUrl,
      requestUrl: `Agreement/GetAssociationsWithEvaluatedDynamicAssociation?agreementId=${sysId}&contractType=${entityName}&evaluateDynamicAssociations=true&skipAmendment=true&skipPeer=true&skipMaster=true`,
      requestMethod: TEXT.GET,
      history: history,
      errMsg: errorValidationMsg.ERROR_LOADING_ASSOCIATIONS,
      onRetry: retryFunctionCall,
    })
  );
};

export const associationPartTwoApiCall = ({
  dispatch,
  history,
  errorValidationMsg,
  retryFunctionCall,
  requestData,
}) => {
  const { ids } = requestData;
  const nonDefaultBaseUrl = configService.getApiUrl().toString().replace("serviceapi/", "");
  return dispatch(
    apiCall({
      requestBaseUrl: nonDefaultBaseUrl,
      requestUrl: `api/Instance/FindProjections`,
      requestMethod: TEXT.POST,
      requestData: [
        "ContractType",
        "en-US",
        [],
        [
          {
            IsAssociatedSearch: false,
            TimeZone: null,
            Join: 1,
            PropertyName: "EntityInstanceId",
            Operator: 1,
            DataType: 4,
            Value: ids,
            AssociationSubQuery: false,
          },
          {
            IsAssociatedSearch: false,
            TimeZone: null,
            Join: 1,
            PropertyName: "IsLatest",
            Operator: 3,
            DataType: 1,
            Value: 1,
          },
          {
            IsAssociatedSearch: false,
            TimeZone: null,
            Join: 1,
            PropertyName: "IsPublished",
            Operator: 3,
            DataType: 1,
            Value: 1,
          },
          {
            IsAssociatedSearch: false,
            TimeZone: null,
            Join: 1,
            PropertyName: "Status",
            Operator: 3,
            DataType: 0,
            Value: "Approved",
          },
        ],
        false,
        false,
        [
          {
            Order: 1,
            Sort: 0,
            SortProperty: "CreatedDate",
          },
        ],
        null,
        false,
        null,
        -1,
        0,
      ],
      history: history,
      errMsg: errorValidationMsg.ERROR_LOADING_ASSOCIATIONS,
      onRetry: retryFunctionCall,
    })
  );
};

export const attributeApiCall = ({ dispatch, history, errorValidationMsg, retryFunctionCall }) => {
  const nonDefaultBaseUrl = configService.getApiUrl().toString().replace("serviceapi/", "");
  return dispatch(
    apiCall({
      requestBaseUrl: nonDefaultBaseUrl,
      requestUrl: `api/instance/FindProjectionsKeyValuePair`,
      requestMethod: TEXT.POST,
      requestData: [
        "ContractTypeAttribute",
        "en-US",
        ["SysId", "AttributeId", "Name", "ICMDisplayName", "DataType", "IsAttributeLocalized"],
        [
          { Join: 0, PropertyName: "DataType", Operator: 3, DataType: 0, Value: 0 },
          { Join: 0, PropertyName: "DataType", Operator: 3, DataType: 0, Value: 7 },
          { Join: 0, PropertyName: "DataType", Operator: 3, DataType: 0, Value: 11 },
          { Join: 0, PropertyName: "DataType", Operator: 3, DataType: 0, Value: 13 },
          { Join: 0, PropertyName: "DataType", Operator: 3, DataType: 0, Value: 15 },
          { Join: 0, PropertyName: "DataType", Operator: 3, DataType: 0, Value: 16 },
          { Join: 0, PropertyName: "DataType", Operator: 3, DataType: 4, Value: 0 },
          { Join: 1, PropertyName: "IsSearchable", Operator: 3, DataType: 1, Value: 1 },
        ],
        [{ Order: 1, Sort: 0, SortProperty: "ETag" }],
        null,
        false,
        null,
        -1,
        0,
        0,
      ],
      history: history,
      errMsg: errorValidationMsg.ERROR_LOADING_ATTRIBUTES,
      onRetry: retryFunctionCall,
    })
  );
};

export const instanceApiCall = ({ dispatch, history, errorValidationMsg, retryFunctionCall, requestData }) => {
  const nonDefaultBaseUrl = configService.getApiUrl().toString().replace("serviceapi/", "");
  const { agreementId, associationCT, page, pageSize, searchTerm = "", errMsg = "" } = requestData;
  return dispatch(
    apiCall({
      requestBaseUrl: nonDefaultBaseUrl,
      requestUrl: `api/Agreement/FindAgreements?contractType=${associationCT}&page=${page}&pageSize=${pageSize}`,
      requestMethod: TEXT.POST,
      requestData: [
        {
          Join: 0,
          PropertyName: "Name",
          Operator: 0,
          DataType: 0,
          Value: searchTerm,
        },
        {
          Join: 1,
          PropertyName: "ParentId",
          Operator: 3,
          DataType: 0,
          Value: agreementId,
        },
      ],
      history: history,
      errMsg: errMsg || errorValidationMsg.ERROR_LOADING_ASSOCIATION_INSTANCES,
      onRetry: retryFunctionCall,
    })
  );
};

export const bactInstanceApiCall = ({ dispatch, history, errorValidationMsg, retryFunctionCall, requestData }) => {
  const nonDefaultBaseUrl = configService.getApiUrl().toString().replace("serviceapi/", "");
  const { agreementId, agreementCT, associationCT, page, pageSize, searchTerm = "", errMsg = "" } = requestData;
  if (searchTerm) {
    return dispatch(
      apiCall({
        requestBaseUrl: nonDefaultBaseUrl,
        requestUrl: `api/Instance/GetFilteredBACTInstances?entityName=${associationCT}&parentEntityName=${agreementCT}&parentId=${agreementId}&pageNumber=${page}&pageSize=${pageSize}`,
        requestMethod: TEXT.POST,
        requestData: [
          [
            {
              Join: 0,
              PropertyName: "Name",
              Operator: 0,
              DataType: 0,
              Value: searchTerm,
            },
          ],
          "",
        ],
        history: history,
        errMsg: errMsg || errorValidationMsg.ERROR_LOADING_ASSOCIATION_INSTANCES,
        onRetry: retryFunctionCall,
      })
    );
  }
  return dispatch(
    apiCall({
      requestBaseUrl: nonDefaultBaseUrl,
      requestUrl: `api/Instance/GetFilteredBACTInstances?entityName=${associationCT}&parentEntityName=${agreementCT}&parentId=${agreementId}&pageNumber=${page}&pageSize=${pageSize}`,
      requestMethod: TEXT.POST,
      history: history,
      errMsg: errMsg || errorValidationMsg.ERROR_LOADING_ASSOCIATION_INSTANCES,
      onRetry: retryFunctionCall,
    })
  );
};

export const getFileApiCall = ({ dispatch, history, errorValidationMsg, retryFunctionCall, requestData }) => {
  const baseUrl = configService.getApiUrl().toString();
  const { agreementId, contractType, extension } = requestData;
  return dispatch(
    apiCall({
      requestBaseUrl: baseUrl,
      requestUrl: `Agreement/GetFile?fileType=${extension}&agreementId=${agreementId}&contractType=${contractType}`,
      requestMethod: TEXT.GET,
      requestData: requestData,
      history: history,
      errMsg: errorValidationMsg.ERROR_UPLOAD_DOCUMENT,
      onRetry: retryFunctionCall,
    })
  );
};

export const displayAttributesApiCall = ({ dispatch }) => {
  const baseUrl = configService.getApiUrl().toString();
  const masterDataCT = configService.getVisibleAttrsConfigMasterDataContractType();
  const masterDataCTSysId = configService.getVisibleAttrsConfigMasterDataSysID();
  return dispatch(
    apiCallWithoutErrorNotification({
      requestBaseUrl: baseUrl,
      requestUrl: `Masterdata/Get?id=${masterDataCTSysId}&contractType=${masterDataCT}&includeChildCollections=True&fetchAuditEntries=False`,
      requestMethod: TEXT.GET,
    })
  );
};

export const fetchFileApiCall = ({ dispatch, filePath }) => {
  const baseUrl = configService.getApiUrl().toString();
  return dispatch(
    apiCallWithoutErrorNotification({
      requestBaseUrl: baseUrl,
      requestUrl: `Agreement/GetFile?filePath=${encodeURIComponent(filePath)}`,
      requestMethod: TEXT.GET,
    })
  );
};

export const getPreviewDataApiCall = ({ dispatch, filePath, requestData }) => {
  const baseUrl = configService.getApiUrl().toString();
  return dispatch(
    apiCallForPreview({
      requestBaseUrl: baseUrl,
      requestUrl: `Agreement/GetFile?filePath=${filePath}`,
      requestMethod: TEXT.GET,
      requestData: requestData,
    })
  );
};

export const apiCall =
  ({ requestBaseUrl, requestUrl, requestMethod, requestData = null, history, errMsg, onRetry = () => {} }) =>
  async (dispatch) => {
    dispatch(hideNotification());
    const headers = getHeaders();
    try {
      const response = await axios({
        baseURL: requestBaseUrl,
        url: requestUrl,
        method: requestMethod,
        headers: headers,
        data: requestData,
      });
      return { response: response.data, error: null };
    } catch (error) {
      console.log(`error in api call [${requestUrl}]:`, error);
      const ifErrorStatus = error && error.response && error.response.status;
      if (ifErrorStatus && error.response.status === UNAUTHORISED_STATUS_CODE) {
        redirectToLogin(history);
        return;
      }
      if (ifErrorStatus && error.response.status === FORBIDDEN_STATUS_CODE) {
        dispatch(showNotificationWarning(TEXT.FORBIDDEN_WARNING));
        return;
      }
      let errorCode = "";
      let errMessage = "";
      let correlationId = "";
      if (error && error.response && error.response.data) {
        errorCode = extractErrorCode(error.response.data);
        if (errorCode) {
          correlationId = extractCorrelationId(error.response.data);
          errMessage = extractErrorMessage(error.response.data, correlationId, errorCode);
        }
      }
      dispatch(
        showNotificationError({
          message: errMsg,
          errorCode,
          errMessage,
          correlationId,
          retryFunction: () => onRetry(),
        })
      );
      return { response: null, error: error };
    }
  };

export const apiCallWithoutErrorNotification =
  ({ requestBaseUrl, requestUrl, requestMethod, requestData = null }) =>
  async (dispatch) => {
    dispatch(hideNotification());
    const headers = getHeaders();
    try {
      const response = await axios({
        baseURL: requestBaseUrl,
        url: requestUrl,
        method: requestMethod,
        headers: headers,
        data: requestData,
      });
      return { response: response.data, error: null };
    } catch (error) {
      console.log(`error in api call [${requestUrl}]:`, error);
      return { response: null, error: error };
    }
  };

export const apiCallForPreview =
  ({ requestBaseUrl, requestUrl, requestMethod, requestData = null }) =>
  async (dispatch) => {
    dispatch(hideNotification());
    const headers = getPreviewHeaders(requestData);
    try {
      const response = await axios({
        baseURL: requestBaseUrl,
        url: requestUrl,
        method: requestMethod,
        headers: headers,
        data: requestData,
      });
      return { response: response.data, error: null };
    } catch (error) {
      console.log(`error in api call [${requestUrl}]:`, error);
      return { response: null, error: error };
    }
  };

export const getHeaders = () => {
  const isIdpEnabled = configService.getOauthFlag().toString();
  let headers = null;
  if (isIdpEnabled === "false") {
    const token = sessionService.getAuthToken().replace(/['"]+/g, "");
    headers = { "Content-Type": "application/json", icmauthtoken: token, iciAppAgent: "ICIOutlookAddIn" };
  } else {
    const idpToken = sessionService.getIdpAccessToken();
    headers = {
      authorization: `Bearer ${idpToken}`,
      "Content-Type": "application/json",
      iciAppAgent: "ICIOutlookAddIn",
    };
  }
  return headers;
};

const redirectToLogin = (history) => {
  sessionService.resetSession();
  history.push(ROUTE.LOG_OUT_ICI);
  window.location.reload();
};

const extractErrorCode = (msg) => {
  if (typeof msg !== "string") {
    return "";
  }
  const regexText = msg.match(/\[(.*?)\]/gm);
  const transformedText = regexText && regexText[0] ? regexText[0].replace(/[[\]]/g, "").trim() : "";
  return transformedText;
};

const extractCorrelationId = (msg) => {
  const regexText = msg.match(/([a-z0-9]+\-).*/gm);
  const transformedText = regexText && regexText[0] ? regexText[0].replace(/(\[.*?\])/g, "").trim() : "";
  return transformedText;
};

const extractErrorMessage = (msg, correlationId, errorCode) => {
  const transformedText = msg
    .replace(correlationId, "")
    .replace(errorCode, "")
    .replace(/[^A-Za-z0-9\s]/g, "")
    .trim();
  return transformedText;
};

const getPreviewHeaders = (token) => {
  const isIdpEnabled = configService.getOauthFlag().toString();
  let headers = null;
  if (isIdpEnabled === "false") {
    headers = { "Content-Type": "application/json", icmauthtoken: token, iciAppAgent: "ICIOutlookAddIn" };
  } else {
    headers = {
      authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      iciAppAgent: "ICIOutlookAddIn",
    };
  }
  return headers;
};
